import { AccountBalance, Description, FindInPage } from "@material-ui/icons";

export const requestTypeKeys = {
    petition: 'petition',
    hearing: 'hearing',
};

export const requestServices = {
    PETITION: 'petition',
    ANALYSIS: 'analysis',
    CALCULATION: 'calculation',
    HEARING: 'hearing',
    HEARINGANALYSIS: 'hearingAnalysis',
    HEARINGINPERSON: 'hearingInPerson',
    NOTION: 'notion',
    CONTRACT: 'contract',
    ISSUEPAYMENTFEE: 'issuePaymentFee',
    EXTRAJUDICIALDOCUMENT: 'extrajudicialDocument',
    structure: {
        petition: {
            id: 1,
            name: "Petição",
            key: "petition",
            databaseKey: 'forwardToPetition',
            icon: Description,
            grammaticalGender: 'feminine',
            description: 'Um profissional jurídico especializado irá elaborar um documento formal, conforme as necessidades específicas do seu caso. Você receberá uma petição detalhada e juridicamente correta, pronta para ser protocolada no processo judicial.',
            shortDescription: 'Elaboração de petição jurídica.',
            emoji: '📄',
            marketplaceName: 'Petição Jurídica',
            marketplaceDescription: 'Produção sem limite de complexidade',
            marketplaceTag: 'Mais usado',
            serviceDocumentAcceptTypeFiles: ['.doc', '.docx', '.pdf'],
            conflictingServices: ['notion']
        },
        analysis: {
            id: 2,
            name: "Indicação de Petição",
            key: "analysis",
            databaseKey: 'forwardToAnalysis',
            icon: FindInPage,
            grammaticalGender: 'feminine',
            description: 'Uma análise detalhada do seu caso por um advogado, que indicará qual petição é mais adequada para a sua situação.',
            shortDescription: 'Análise para indicação de petição.',
            noDocuments: true,
            conflictingServices: ['notion']
        },
        calculation: {
            id: 3,
            name: "Cálculo",
            key: "calculation",
            databaseKey: 'forwardCalculationServiceId',
            icon: AccountBalance,
            grammaticalGender: 'masculine',
            description: 'Um profissional especializado realizará os cálculos necessários, como liquidação de sentença, atualização de valores, juros e correções monetárias. Você receberá um relatório detalhado e preciso com todos os cálculos necessários para o seu caso, pronto para ser utilizado no processo judicial.',
            shortDescription: 'Cálculo jurídico e financeiro.',
            emoji: '📊',
            marketplaceName: 'Cálculos Jurídicos',
            marketplaceDescription: 'Iniciais e complexos, em diversas áreas',
        },
        hearing: {
            id: 4,
            name: "Audiência Virtual",
            key: "hearing",
            icon: Description,
            grammaticalGender: 'feminine',
            description: 'Você contará com a representação de um advogado experiente em uma sessão por videoconferência. Você receberá um relatório completo sobre os resultados da audiência e as próximas etapas a serem seguidas, além de ter a garantia de uma defesa profissional e eficaz no ambiente digital.',
            shortDescription: 'Representação em audiência virtual.',
            emoji: '🎥',
            marketplaceName: 'Audiência Virtual',
            marketplaceDescription: 'Presença garantida, sem deslocamento',
        },
        contract: {
            id: 6,
            name: "Contrato",
            key: "contract",
            icon: Description,
            grammaticalGender: 'masculine',
            description: 'Um advogado especializado redigirá um documento personalizado conforme as suas necessidades e especificações. Você receberá um contrato juridicamente válido e detalhado, pronto para ser assinado pelas partes envolvidas, garantindo que todos os direitos e deveres estejam claramente definidos e protegidos.',
            shortDescription: 'Elaboração de contrato jurídico.',
            emoji: '📝',
            marketplaceName: 'Contrato Personalizado',
            marketplaceDescription: 'Minutas sob medida',
            serviceDocumentAcceptTypeFiles: ['.doc', '.docx', '.pdf'],
        },
        notion: {
            id: 7,
            name: "Parecer",
            key: "notion",
            icon: Description,
            grammaticalGender: 'masculine',
            databaseKey: 'forwardToNotion',
            description: 'Uma análise jurídica detalhada sobre a sua questão específica, elaborada por um profissional qualificado. O parecer fornecerá uma avaliação profunda e fundamentada, com orientações claras e sugestões sobre a melhor forma de agir, ajudando você a tomar decisões informadas e seguras.',
            shortDescription: 'Parecer jurídico fundamentado.',
            emoji: '📚',
            marketplaceName: 'Parecer Jurídico',
            marketplaceDescription: 'Análise técnica aprofundada',
            serviceDocumentAcceptTypeFiles: ['.doc', '.docx', '.pdf'],
            conflictingServices: ['petition', 'analysis']
        },
        hearingInPerson: {
            id: 8,
            name: "Audiência Presencial",
            key: "hearingInPerson",
            icon: Description,
            grammaticalGender: 'feminine',
            description: 'Um advogado capacitado irá comparecer ao tribunal para representar e defender seus interesses. Você receberá um relatório detalhado sobre o andamento e os resultados da audiência, além de orientação sobre os próximos passos a serem tomados no processo judicial.',
            shortDescription: 'Representação em audiência presencial.',
            emoji: '🏛️',
            marketplaceName: 'Audiência Presencial',
            marketplaceDescription: 'Seu escritório em qualquer tribunal',
        },
        issuePaymentFee: {
            id: 9,
            name: "Emissão de Guias",
            key: "issuePaymentFee",
            databaseKey: 'forwardToIssuePaymentFee',
            icon: Description,
            grammaticalGender: 'feminine',
            description: 'Emissão de documentos para o pagamento de custas processuais ou despesas relacionadas a um processo judicial.',
            shortDescription: 'Emissão de guias judiciais.',
            emoji: '🧾',
            marketplaceName: 'Emissão de Guias',
            marketplaceDescription: 'Custas certas, no prazo certo',
        },
        extrajudicialDocument: {
            id: 10,
            name: "Documento Extrajudicial",
            key: "extrajudicialDocument",
            databaseKey: 'forwardToExtrajudicialDocument',
            icon: Description,
            grammaticalGender: 'masculine',
            description: 'Um profissional jurídico especializado elaborará um documento extrajudicial personalizado conforme a sua necessidade, como notificações, acordos e demais instrumentos. Você receberá um documento juridicamente correto, pronto para ser utilizado fora do processo judicial.',
            shortDescription: 'Elaboração de documento extrajudicial.',
            emoji: '📃',
            marketplaceName: 'Documento Extrajudicial',
            marketplaceDescription: 'Notificações, acordos e outros documentos',
            serviceDocumentAcceptTypeFiles: ['.doc', '.docx', '.pdf'],
        }
    }
};

export const servicesByTypeKey = {
    legalDocument: {
        id: 1,
        services: [
            'analysis',
            'calculation',
            'petition',
            'extrajudicialDocument'
        ]
    },
    calculation: {
        id: 2,
        services: [
            'calculation'
        ]
    },
    hearing: {
        id: 3,
        services: [
            'hearing',
            'hearingInPerson'
        ]
    }
};

export const MARKETPLACE_SERVICES_ORDER = ['petition', 'extrajudicialDocument', 'calculation', 'hearing', 'contract', 'hearingInPerson', 'notion', 'issuePaymentFee'];

export const MARKETPLACE_SHOWCASE_SERVICES_ORDER = ['petition', 'extrajudicialDocument', 'calculation', 'contract', 'notion', 'issuePaymentFee'];

export const SERVICE_MIN_PRICE_KEYS = {
    CALCULATION_INITIAL: 'calculation.initial',
    CALCULATION_COMPLEX: 'calculation.complex',
};

export const buildServiceRowKey = (packageService) => {
    if (packageService?.calculationComplexity) {
        return packageService.calculationComplexity === 'high'
            ? SERVICE_MIN_PRICE_KEYS.CALCULATION_COMPLEX
            : SERVICE_MIN_PRICE_KEYS.CALCULATION_INITIAL;
    }
    return packageService?.serviceKey;
};

export const onlyAdditionalServicesKey = ['hearingAnalysis']

export const AREA_DISPLAY_ORDER = [2, 5, 3, 7, 1, 4, 6, 8];

export const MODALITY_POSITION_SWAP = { 8: 9, 9: 8 };
